import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Star, Plus, Minus, ShoppingCart, ArrowLeft, ShieldCheck, Truck, RotateCcw } from 'lucide-react';
import { PRODUCTS, getCategory } from '../mock/mock';
import { useCart } from '../context/CartContext';
import ProductCard from '../components/ProductCard';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [qty, setQty] = useState(1);
  const product = PRODUCTS.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <h1 className="font-anton text-4xl ps-blue-text mb-4">Product not found</h1>
        <Link to="/products" className="ps-blue-bg text-white px-6 py-3 rounded-full font-oswald uppercase btn-press">Back to products</Link>
      </div>
    );
  }

  const category = getCategory(product.category);
  const related = PRODUCTS.filter((p) => p.category === product.category && p.id !== product.id).slice(0, 4);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-gray-500 hover:text-[#1a1ad6] font-oswald uppercase text-sm mb-8"><ArrowLeft size={16} /> Back</button>

      <div className="grid md:grid-cols-2 gap-10">
        <div className="rounded-3xl overflow-hidden shadow-lg bg-gray-50">
          <img src={product.image} alt={product.name} className="w-full h-full max-h-[520px] object-cover" />
        </div>
        <div>
          {category && <Link to={`/category/${category.slug}`} className="font-oswald uppercase text-sm text-[#1a1ad6] tracking-wide">{category.name}</Link>}
          <h1 className="font-anton text-4xl sm:text-5xl text-gray-900 mt-2 leading-tight">{product.name}</h1>
          <div className="flex items-center gap-2 mt-3">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={18} className={i < product.rating ? 'fill-[#ffd400] text-[#ffd400]' : 'text-gray-300'} />
              ))}
            </div>
            <span className="text-sm text-gray-400">({product.rating}.0)</span>
          </div>
          <p className="text-gray-600 leading-relaxed mt-6">{product.desc}</p>

          <div className="flex items-center gap-4 mt-8">
            <div className="flex items-center border border-gray-200 rounded-xl overflow-hidden">
              <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-11 h-12 flex items-center justify-center hover:bg-gray-100"><Minus size={18} /></button>
              <span className="w-12 text-center font-oswald text-lg">{qty}</span>
              <button onClick={() => setQty((q) => q + 1)} className="w-11 h-12 flex items-center justify-center hover:bg-gray-100"><Plus size={18} /></button>
            </div>
            <button onClick={() => addItem(product, qty)} className="flex-1 ps-blue-bg text-white py-3.5 rounded-xl font-oswald uppercase tracking-wide text-lg btn-press hover:bg-[#0f0fa0] flex items-center justify-center gap-2">
              <ShoppingCart size={20} /> Add to Cart
            </button>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t">
            {[
              { icon: ShieldCheck, t: 'Non-Toxic' },
              { icon: Truck, t: 'Fast Shipping' },
              { icon: RotateCcw, t: 'Easy Returns' },
            ].map((f, i) => (
              <div key={i} className="flex flex-col items-center text-center gap-2">
                <f.icon size={24} className="text-[#1a1ad6]" />
                <span className="font-oswald uppercase text-xs text-gray-500">{f.t}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {related.length > 0 && (
        <div className="mt-20">
          <h2 className="font-anton text-3xl ps-blue-text mb-8">YOU MAY ALSO LIKE</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6">
            {related.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetail;
